// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RepositoryFactories<Options> = Record<string, (options: Options) => Record<string, any>>;

type Registry<F extends RepositoryFactories<Options>, Options> = {
    [K in keyof F]: ReturnType<F[K]>;
};

export const createRepositoryRegistryFromFactories = <Factories extends RepositoryFactories<Options>, Options>(
    repositoryFactories: Factories,
    options: Options
) => {
    const registry = {} as Record<string, unknown>;

    Object.entries(repositoryFactories).forEach(([name, createRepository]) => {
        registry[name] = createRepository(options);
    });

    return registry as Registry<Factories, Options>;
};
